import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl, Iframe } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook

/*
 * Notice Detail
 * !== 업무파트용 통보 상세 ==!
 */
export const DclrNtcDtl = (): JSX.Element => {
    const pgeUid = "UI-PTLE-0605-002Q";
    const { t } = useTranslation();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { getParams } = usePopup();
    const { frontDmn, dclrNtcUrlAddr, dclrNtcReffId } = getParams(); // Parameters to forward when calling a Approval request  결재요청 팝업 호출시 전달해야할 파라메터 (업무분류코드,결재후처리설정ID,신고문서코드)
    const [iframeSrc, setIframeSrc] = useState(frontDmn + dclrNtcUrlAddr + dclrNtcReffId);

    return (
        <Page id={pgeUid} title={t("T_PRCSS_STAT_DTL")}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            {!comnUtils.isEmpty(iframeSrc) && <Iframe src={`${iframeSrc}`} height={900} />}
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
        </Page>
    );
};
